// extracted by mini-css-extract-plugin
module.exports = {"container":"_1TzzuY","title":"_2aA32F","content":"_1XSoID"};